var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyValidate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 200,
    viewBox: "0 0 320 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M48.8253 74.4487C48.8253 74.4487 6.83443 169.092 117.394 170.418C227.953 171.744 278.496 157.209 278.995 109.086C279.495 60.9633 239.678 15.9686 170.272 15.5086C100.866 15.0486 63.332 33.0802 48.8253 74.4487Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M212.244 41.5H143L143.951 109.5H239V68.2928C238.998 61.1862 236.178 54.3714 231.161 49.347C226.143 44.3226 219.339 41.5 212.244 41.5Z",
    fill: "#0D9F3F",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.5 41.5C149.528 41.5 156.269 44.3236 161.238 49.3497C166.208 54.3757 169 61.1925 169 68.3005V109.5H116V68.2928C116.002 61.1862 118.795 54.3714 123.764 49.347C128.734 44.3226 135.473 41.5 142.5 41.5Z",
    fill: "#24285B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.5 177.5C135.472 177.5 128.731 174.676 123.762 169.65C118.792 164.624 116 157.807 116 150.7V109.5H169V150.7C169 157.807 166.208 164.624 161.238 169.65C156.269 174.676 149.528 177.5 142.5 177.5Z",
    fill: "#0D9F3F",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M142.5 177.5C135.472 177.5 128.731 174.676 123.762 169.65C118.792 164.624 116 157.807 116 150.7V109.5H169V150.7C169 157.807 166.208 164.624 161.238 169.65C156.269 174.676 149.528 177.5 142.5 177.5Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M192.533 11.5C192.922 11.5 193.295 11.6616 193.57 11.9491C193.845 12.2367 194 12.6267 194 13.0334V69.5H191V13.064C191 12.6574 191.155 12.2673 191.43 11.9798C191.705 11.6922 192.078 11.5307 192.467 11.5307L192.533 11.5Z",
    fill: "#0D9F3F",
    fillOpacity: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M192.533 11.5C192.922 11.5 193.295 11.6616 193.57 11.9491C193.845 12.2367 194 12.6267 194 13.0334V69.5H191V13.064C191 12.6574 191.155 12.2673 191.43 11.9798C191.705 11.6922 192.078 11.5307 192.467 11.5307L192.533 11.5Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M193 75.5C196.314 75.5 199 72.8137 199 69.5C199 66.1863 196.314 63.5 193 63.5C189.686 63.5 187 66.1863 187 69.5C187 72.8137 189.686 75.5 193 75.5Z",
    fill: "#FFD200"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M194 13.5H209V18.9742L194 22.5V13.5Z",
    fill: "#FFD200"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M205 109.5H180V119.5H205V109.5Z",
    fill: "#24285B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M199 119.5H186V193.5H199V119.5Z",
    fill: "#0D9F3F",
    fillOpacity: 0.8
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M199 119.5H186V193.5H199V119.5Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M186 119.5V144.5L199 136.503V119.5H186Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6502 36.8594L91.1559 20.5L94.1977 32.8984C94.4975 34.0942 95.1079 35.1839 95.9638 36.0508C96.8197 36.9177 97.8889 37.5294 99.057 37.8203L108 40.0469L99.711 42.5391C98.3953 42.9434 97.2002 43.6824 96.2364 44.6875C95.2727 45.6926 94.5714 46.9314 94.1977 48.2891L91.0646 59.5L88.2814 47.5234C88.0351 46.4688 87.5088 45.505 86.7609 44.7395C86.0131 43.974 85.0731 43.4367 84.0456 43.1875L76 41.25L87.6502 36.8594Z",
    fill: "#FFD200"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M168.078 60.0864L170.802 47.5L173.213 57.0384C173.449 57.9613 173.929 58.8014 174.601 59.468C175.273 60.1346 176.112 60.6026 177.027 60.8213L184 62.5387L177.531 64.4572C176.499 64.7626 175.561 65.3278 174.803 66.1002C174.046 66.8726 173.493 67.827 173.197 68.8744L170.756 77.5L168.574 68.2865C168.385 67.4731 167.975 66.7294 167.391 66.1391C166.808 65.5487 166.074 65.135 165.271 64.9446L159 63.4515L168.078 60.0864Z",
    fill: "#FFD200"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1894 119.309L85.0439 110.5L86.6798 117.17C86.8389 117.815 87.1626 118.403 87.6167 118.871C88.0707 119.339 88.638 119.67 89.2581 119.828L94 121.024L89.6049 122.369C88.9007 122.581 88.26 122.977 87.743 123.519C87.226 124.061 86.8498 124.732 86.6497 125.467L84.9911 131.5L83.5286 125.051C83.4016 124.476 83.1223 123.949 82.7223 123.532C82.3224 123.115 81.8181 122.823 81.267 122.691L77 121.645L83.1894 119.309Z",
    fill: "#FFD200"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M128.726 90.212L130.142 83.5L131.397 88.588C131.516 89.08 131.763 89.5286 132.111 89.8853C132.458 90.2421 132.892 90.4933 133.367 90.612L137 91.524L133.606 92.548C133.068 92.7111 132.58 93.0131 132.185 93.4259C131.791 93.8386 131.504 94.3485 131.351 94.908L130.104 99.5L128.988 94.596C128.888 94.1613 128.674 93.764 128.37 93.4489C128.065 93.1337 127.682 92.9131 127.263 92.812L124 92.012L128.726 90.212Z",
    fill: "#FFD200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyValidate);
export default __webpack_public_path__ + "static/media/empty-validate.513253560f4677a3c40e5d1bcf4a1b76.svg";
export { ForwardRef as ReactComponent };